import { colors } from '@datacamp/waffles-tokens';
import * as React from 'react';
import { Spinner } from './Spinner';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const GraphicalOutputPlaceholder = _ref => {
  let {
    className = '',
    message
  } = _ref;
  return ___EmotionJSX("div", {
    className: "dc-u-h-100pc dc-u-fx dc-u-fx-fdc dc-u-fx-center dc-u-brad-all ".concat(className),
    style: {
      border: "1px dashed ".concat(colors.greySubtle)
    }
  }, ___EmotionJSX(Spinner, {
    center: false,
    color: "navy"
  }), message && ___EmotionJSX("p", {
    className: "dc-u-fw-bold"
  }, message));
};